import type { DotsItem } from 'react-alice-carousel'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

export const DotsItemComponent = ({ isActive }: DotsItem) => (
  <div className={css.dots}>
    <span className={clsJoin(css.dots_inner, isActive && css.active)} />
  </div>
)
